import React from "react";

const Absolventi = () => {
  return (
    <div>
      <h1>Absolventi</h1>
      <p>nevimmm</p>
    </div>
  );
};

export default Absolventi;